import { Component, Input } from '@angular/core';
import { DrivingRecordCredentialModel } from '../models/driver-record-credential.model';
import { DriverImageStatusType } from '../../driver/models/enums/driver-image-status-type.enum';

@Component({
    selector: 'driver-record-credential',
    templateUrl: './driver-record-credential.html',
})
export class DriverRecordCredentialComponent {
    @Input() data?: DrivingRecordCredentialModel;
    @Input() isUserLecu = false;
    @Input() isRestrictedCustomer = false;

    public driverImageStatusType = new DriverImageStatusType();
}
